import { BATTLESHIP, CALYPSO_LIGHT, CALYPSO_MEDIUM, EERIE, GREAT_WHITE, GYPSUM, HEFFALUMP, OLAF, SLINKY } from 'HubStyleTokens/colors';
import styled from 'styled-components';
import UIAlert from 'UIComponents/alert/UIAlert';
import UICardSection from 'UIComponents/card/UICardSection';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import { H3, H5 } from 'UIComponents/elements/headings';
import UIRadioInput from 'UIComponents/input/UIRadioInput';
import { devices } from '../styles/viewports.styles';
import { PricingTier } from '../types';
export const Grid = styled.div.withConfig({
  displayName: "PricingAndTrialstyles__Grid",
  componentId: "sc-1yq3pdf-0"
})(["display:inline-grid;background:", ";width:100% !important;min-width:800px;grid-template-columns:calc(280 / 800 * 100%) calc(260 / 800 * 100%) calc( 260 / 800 * 100% );@media ", "{min-width:1020px;grid-template-columns:repeat(3,1fr);}"], OLAF, devices.desktop);
export const CardButton = styled.div.withConfig({
  displayName: "PricingAndTrialstyles__CardButton",
  componentId: "sc-1yq3pdf-1"
})(["button{font-size:14px !important;width:auto !important;", "}"], props => [PricingTier.Starter, PricingTier.Professional].includes(props.tier) && `
      background-color: ${OLAF} !important;
      border-color: ${EERIE} !important;
      color: ${HEFFALUMP} !important;

      &:hover {
        background-color: ${GYPSUM} !important;
        border-color: ${EERIE} !important;
      }

      &:active{
        background-color: ${BATTLESHIP} !important;
        border-color: ${EERIE} !important;
      }
    `);
export const GridCell = styled.div.withConfig({
  displayName: "PricingAndTrialstyles__GridCell",
  componentId: "sc-1yq3pdf-2"
})(["display:flex;flex-direction:column !important;grid-column-start:", ";grid-row-start:", ";padding-left:20px;padding-right:20px;", ""], props => props.gridColumnStart, props => props.gridRowStart, props => props.tier === PricingTier.Free ? `
    border-right: 1px solid #ff5c35;
    border-left: 1px solid #ff5c35;
  ` : `
    border-right: 1px solid ${GREAT_WHITE};
  `);
export const PricingBannerWrapper = styled.div.withConfig({
  displayName: "PricingAndTrialstyles__PricingBannerWrapper",
  componentId: "sc-1yq3pdf-3"
})(["border-top-left-radius:10px;border-top-right-radius:10px;padding-left:32px;padding-right:32px;grid-column-start:", ";grid-row-start:1;background-color:#ff5c35;color:", ";display:flex;justify-content:center;flex-direction:column;text-align:center;height:32px;font-weight:500;", ""], props => props.gridColumnStart, OLAF, props => props.tier === PricingTier.Starter && `
    grid-column: span 2;
    background-color: ${GYPSUM};
    color: ${SLINKY};
    border-bottom: 1px solid ${GREAT_WHITE};
  `);
export const BorderLastCellByTier = {
  [PricingTier.Free]: {
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
    borderBottom: `1px solid #FF5C35`
  },
  [PricingTier.Starter]: {
    borderBottomLeftRadius: 10,
    borderBottom: `1px solid ${GREAT_WHITE}`
  },
  [PricingTier.Professional]: {
    borderBottomRightRadius: 10,
    borderBottom: `1px solid ${GREAT_WHITE}`
  }
};
export const TrialCardWrapper = styled(UICardWrapper).withConfig({
  displayName: "PricingAndTrialstyles__TrialCardWrapper",
  componentId: "sc-1yq3pdf-4"
})(["border:1px solid ", ";cursor:pointer;&:hover{background-color:", ";box-shadow:0 4px 20px ", ";}", ";"], CALYPSO_MEDIUM, CALYPSO_LIGHT, CALYPSO_LIGHT, props => props.isChecked && `
    background-color: ${CALYPSO_LIGHT};
  `);
export const FlexColumnWrapper = styled.div.withConfig({
  displayName: "PricingAndTrialstyles__FlexColumnWrapper",
  componentId: "sc-1yq3pdf-5"
})(["display:flex;flex-direction:column;align-items:center;"]);
export const PriceContainer = styled(H3).withConfig({
  displayName: "PricingAndTrialstyles__PriceContainer",
  componentId: "sc-1yq3pdf-6"
})(["font-size:26px;margin-bottom:8px;"]);
export const PricingAlert = styled(UIAlert).withConfig({
  displayName: "PricingAndTrialstyles__PricingAlert",
  componentId: "sc-1yq3pdf-7"
})(["margin-bottom:24px;"]);
export const StyledRadioInput = styled(UIRadioInput).withConfig({
  displayName: "PricingAndTrialstyles__StyledRadioInput",
  componentId: "sc-1yq3pdf-8"
})(["margin-left:auto;margin-right:0;"]);
export const DesktopCurrencyContainer = styled.div.withConfig({
  displayName: "PricingAndTrialstyles__DesktopCurrencyContainer",
  componentId: "sc-1yq3pdf-9"
})(["grid-template-rows:auto auto;grid-area:subheader;z-index:1;display:none;margin-top:12px;@media ", "{display:initial;}"], devices.desktop);
export const MobileCurrencyContainer = styled.div.withConfig({
  displayName: "PricingAndTrialstyles__MobileCurrencyContainer",
  componentId: "sc-1yq3pdf-10"
})(["grid-template-rows:auto auto;grid-area:subheader;z-index:1;display:initial;margin-top:12px;@media ", "{display:none;}"], devices.desktop);
export const FlexContainer = styled.div.withConfig({
  displayName: "PricingAndTrialstyles__FlexContainer",
  componentId: "sc-1yq3pdf-11"
})(["display:flex;"]);
export const TrialDescriptionContainer = styled.div.withConfig({
  displayName: "PricingAndTrialstyles__TrialDescriptionContainer",
  componentId: "sc-1yq3pdf-12"
})(["color:", ";font-size:14px;text-align:center;"], SLINKY);
export const TrialTitleContainer = styled(H5).withConfig({
  displayName: "PricingAndTrialstyles__TrialTitleContainer",
  componentId: "sc-1yq3pdf-13"
})(["text-align:center;"]);
export const TrialCardSection = styled(UICardSection).withConfig({
  displayName: "PricingAndTrialstyles__TrialCardSection",
  componentId: "sc-1yq3pdf-14"
})(["padding:12px;"]);